// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/img/bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/Montserrat-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/Montserrat-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/fonts/Montserrat-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/fonts/Montserrat-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/fonts/Montserrat-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/fonts/Montserrat-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  box-sizing: border-box;
  background-color: black;
}

@media screen and (max-width: 1200px) {
  .video {
    display: none;
  }
  html {
    box-sizing: border-box;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center;
    background-attachment: fixed;
    background-size: cover;
  }
}

body {
  margin: 0;
  padding: 0;
}

@font-face {
  font-family: "Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: 300;
}

@font-face {
  font-family: "Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: 400;
}

@font-face {
  font-family: "Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-weight: 500;
}

@font-face {
  font-family: "Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: 600;
}

@font-face {
  font-family: "Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
  font-weight: 700;
}

@font-face {
  font-family: "Montserrat";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
  font-weight: 800;
}

.font-face-mr {
  font-family: "Montserrat";
  font-weight: 800;
}

#root,
.app {
  height: 100%;
}

.section-data-wrapper {
  /*margin-left: 15%;*/
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 50px;
  /*margin-bottom: 50px;*/
  width: 100%;
}

.section-data-wrapper > div:first-child {
  border-top: 2px solid rgba(255, 255, 255, 0.5);
}

/* category button */
.categories-button {
  display: flex;
  align-items: center;
  width: 418px;
  background-color: rgba(255, 255, 255, 0.6);
  border-radius: 10px;
  cursor: pointer;
  height: 80px;
  margin-left: 30px;
}

.categories-button.active {
  background-color: rgba(255, 255, 255, 0.8);
}

.categories-button span {
  margin-left: 30px;
  flex-basis: 100%;
  font-weight: 600;
  color: #555555;
  font-size: 14px;
  font-family: "Montserrat";
  line-height: 17.07px;
  text-transform: uppercase;
}

.categories-button .arrow {
  width: 20px;
  margin-right: 38px;
}

@media only screen and (max-width: 768px) {
  .categories-button {
    width: 247px;
  }
}

@media only screen and (max-width: 480px) {
  .categories-button {
    margin-top: 20px;
    margin-right: 20px;
    margin-left: 0px;
    width: auto;
    height: 70px;
  }

  .categories-button .arrow {
    margin-right: 32px;
  }
}

/* pathBuilder */
.path-builder {
  display: flex;
  margin-top: 40px;
}

.path-builder .breadcrumbs {
  margin-left: 10px;
  text-align: left;
  line-break: anywhere;
  padding-right: 45px;
}


.path-builder .path-part {
  cursor: pointer;
  text-align: left;
}

.path-builder .path-part .path:hover {
  text-decoration: underline;
}

.path-builder .all-categories {
  display: flex;
  padding-top: 2px;
  cursor: pointer;
}

.path-builder div {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
  line-height: 21.94px;
}

@media only screen and (max-width: 1200px) {
  .path-builder .breadcrumbs {
    padding-right: 0px;
  }
}

@media only screen and (max-width: 768px) {
  .path-builder {
    padding: 0 20px 0 0;
  }
}

@media only screen and (max-width: 320px) {
  .path-builder {
    margin-bottom: 20px;
    justify-content: unset;
  }

  .path-builder .breadcrumbs {
    display: flex;
    flex-direction: column;
    line-break: unset;
  }

  .path-builder div {
    text-transform: uppercase;
  }
}

/* sectionBuilder */
.gear-icons {
  display: flex;
  flex-basis: 20%;
  margin-right: 10px;
  width: 30px;
  height: 30px;
  justify-content: center;
  align-items: center;
}

.gear-icons .gear-section-small-gear {
  position: absolute;
  left: 38px;
  top: 10px;
}

.content-wrapper {
  display: inline-flex;
}

.content-wrapper .tooltip-text {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  display: flex;
  align-items: center;
  font-size: 16px;
}

.section-builder {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.section-builder .section-title {
  font-size: 70px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 85px;
  font-weight: bolder;
  margin-bottom: 10px;
}

.section-builder .section-subtitle {
  font-size: 26px;
  color: #ffffff99;
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 20px;
}

.section-builder .section-option-wrapper {
  display: flex;
  width: calc(75% + 30px);
  /*margin-left: 15%;*/
  /* flex-direction: column; */
  flex-wrap: wrap;
  margin-bottom: 30px;
}

.section-builder .section-option-wrapper .section-option {
  /* display: flex; */
  height: 50px;
  border: 2px solid #FFFFFFB2;
  /* justify-content: center; */
  align-items: center;
  border-radius: 40px;
  text-transform: none !important;
  background-color: transparent;
  margin-right: 30px;
  margin-top: 15px;
  cursor: pointer;
  /* backdrop-filter: blur(20px); */
}

.active {
  color: #212121 !important;
  background: rgba(255, 255, 255, 0.7) !important;
}

.section-builder .section-option-wrapp {
  display: flex;
  /* flex-direction: column; */
  flex-wrap: wrap;
  margin-bottom: 30px;
}

.section-builder .section-option-wrapp .section-option {
  display: flex;
  border-top: 1px solid rgba(185, 180, 180, 0.3);
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  text-transform: uppercase;
  background-color: rgba(255, 255, 255, 0.3);
  margin-right: 30px;
  margin-top: 15px;
  cursor: pointer;
  backdrop-filter: blur(20px);
}

.section-builder .section-option-wrapper .section-option.active {
  background: rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

.section-builder .section-option-wrapper .section-option span {
  padding: 20px 50px;
  padding-top: 40px;
  /* padding-left: 15%; */
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  line-height: 17.07px;
  color: rgba(255, 255, 255, 1);
}

.section-builder .section-option-wrapper .section-option.active span {
  /*padding: 26px 15px 26px 50px;*/
  color: #555555;
}

.section-builder .section-option-wrapper .section-option.active span svg {
  margin-left: 17.4px;
  fill: #555555;
  width: 17.6px;
}

.section-builder .section-option-wrapper .section-option.active span svg path {
  fill: #555555;
}

.section-builder .section-data-wrapper .section-data-item {
  margin-bottom: 40px;
}

.section-builder .section-data-wrapper .section-data-item:last-child {
  margin-bottom: 0;
}

.section-builder .section-data-wrapper .section-data-item .section-data-title {
  height: 10%;
  padding-top: 30px;
  font-size: 35px;
  font-weight: bolder;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 10px;
  text-align: left;
  padding-left: 15%;
}

.section-builder
.section-data-wrapper
.section-data-item
.section-data-description {
  height: 55%;
  width: 75%;
  padding-left: 15%;
  padding-top: 30px;
  font-size: 16px;
  color: #ffffff;
  font-weight: 500;
  line-height: 25px;
  text-align: left;
}

@media only screen and (max-width: 1200px) {
  .section-builder
  .section-data-wrapper
  .section-data-item
  .section-data-title {
    font-size: 24px;
  }
}

@media only screen and (max-width: 768px) {
  .section-builder .section-option-wrapper {
    margin-bottom: 20px;
  }
}

@media only screen and (max-width: 480px) {
  .section-builder {
    display: flex;
    text-align: center;
    flex-direction: column;
    justify-content: center;
    margin-top: 20px;
  }

  .section-builder .section-title,
  .section-builder .section-subtitle {
    text-transform: uppercase;
    font-weight: 800;
    font-size: 18px;
    line-height: 22px;
    margin: 0;
  }

  .section-builder .section-option-wrapper .section-option {
    width: 100%;
    margin-right: 0;
    text-align: center;
  }

  .section-builder .section-option-wrapper .section-option span {
    padding: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }

  .section-builder .section-option-wrapper .section-option.active .check-icon {
    margin-right: 20px;
  }

  .section-builder .section-option-wrapper .section-option .check-icon svg {
    position: absolute;
    right: 50px;
  }

  .section-builder .section-option-wrapper {
    justify-content: center;
    align-items: center;
  }
}

@media only screen and (max-width: 320px) {
  .section-builder
  .section-data-wrapper
  .section-data-item
  .section-data-title {
    word-break: break-all;
  }
}

/* thank form */
.thank-you-message-container {
  display: flex;
  flex-direction: column;
  margin-top: 30px;
}

.thank-you-message-container .thank-you-message-title {
  font-size: 36px;
  line-height: 60px;
  font-weight: bolder;
  color: rgba(255, 255, 255, 0.6);
}

.thank-you-message-container > * {
  margin-bottom: 10px;
}

.thank-you-message-container .thank-you-message-content {
  font-size: 20px;
  color: #ffffff;
  font-size: 16px;
  font-weight: 400;
}

.thank-you-message-container .thank-you-message-button {
  margin-top: 10px;
  color: rgba(255, 255, 255, 0.6);
}

.thank-you-message-container .thank-you-message-button button {
  font-family: "Montserrat";
  font-weight: 500;
  font-size: 18px;
  line-height: 21.94px;
  width: 370px;
  color: rgba(255, 255, 255, 0.6);
}

@media only screen and (max-width: 480px) {
  .thank-you-message-container .thank-you-message-title {
    font-size: 16px;
  }

  .thank-you-message-container .thank-you-message-button {
    text-align: center;
  }

  .thank-you-message-container .thank-you-message-button button {
    width: 220px;
    font-weight: 600;
    font-size: 12px;
    line-height: 14.63px;
  }
}
.error-message {
  font-family: "Montserrat";
  width: 77%;
  color: red;
  font-weight: 500;
  font-size: 18px;
  line-height: 21.94px;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,iEAAoD;IACpD,4BAA4B;IAI5B,sBAAsB;EACxB;AACF;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,+DAAkE;EAClE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,+DAAoE;EACpE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,+DAAmE;EACnE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,+DAAqE;EACrE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,+DAAiE;EACjE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,+DAAsE;EACtE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,8CAA8C;AAChD;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;EAC1C,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;;AAGA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,+BAA+B;EAC/B,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;EAIE,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE;;;;IAIE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;;IAEE,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;AACF;;AAEA;EACE;;;;IAIE,qBAAqB;EACvB;AACF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,oBAAoB;EACtB;AACF;AACA;EACE,yBAAyB;EACzB,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB","sourcesContent":["html {\n  box-sizing: border-box;\n  background-color: black;\n}\n\n@media screen and (max-width: 1200px) {\n  .video {\n    display: none;\n  }\n  html {\n    box-sizing: border-box;\n    background: url(\"./assets/img/bg.png\") center center;\n    background-attachment: fixed;\n    -webkit-background-size: cover;\n    -moz-background-size: cover;\n    -o-background-size: cover;\n    background-size: cover;\n  }\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n}\n\n@font-face {\n  font-family: \"Montserrat\";\n  src: url(\"./assets/fonts/Montserrat-Light.ttf\") format(\"truetype\");\n  font-weight: 300;\n}\n\n@font-face {\n  font-family: \"Montserrat\";\n  src: url(\"./assets/fonts/Montserrat-Regular.ttf\") format(\"truetype\");\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: \"Montserrat\";\n  src: url(\"./assets/fonts/Montserrat-Medium.ttf\") format(\"truetype\");\n  font-weight: 500;\n}\n\n@font-face {\n  font-family: \"Montserrat\";\n  src: url(\"./assets/fonts/Montserrat-SemiBold.ttf\") format(\"truetype\");\n  font-weight: 600;\n}\n\n@font-face {\n  font-family: \"Montserrat\";\n  src: url(\"./assets/fonts/Montserrat-Bold.ttf\") format(\"truetype\");\n  font-weight: 700;\n}\n\n@font-face {\n  font-family: \"Montserrat\";\n  src: url(\"./assets/fonts/Montserrat-ExtraBold.ttf\") format(\"truetype\");\n  font-weight: 800;\n}\n\n.font-face-mr {\n  font-family: \"Montserrat\";\n  font-weight: 800;\n}\n\n#root,\n.app {\n  height: 100%;\n}\n\n.section-data-wrapper {\n  /*margin-left: 15%;*/\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  margin-top: 50px;\n  /*margin-bottom: 50px;*/\n  width: 100%;\n}\n\n.section-data-wrapper > div:first-child {\n  border-top: 2px solid rgba(255, 255, 255, 0.5);\n}\n\n/* category button */\n.categories-button {\n  display: flex;\n  align-items: center;\n  width: 418px;\n  background-color: rgba(255, 255, 255, 0.6);\n  border-radius: 10px;\n  cursor: pointer;\n  height: 80px;\n  margin-left: 30px;\n}\n\n.categories-button.active {\n  background-color: rgba(255, 255, 255, 0.8);\n}\n\n.categories-button span {\n  margin-left: 30px;\n  flex-basis: 100%;\n  font-weight: 600;\n  color: #555555;\n  font-size: 14px;\n  font-family: \"Montserrat\";\n  line-height: 17.07px;\n  text-transform: uppercase;\n}\n\n.categories-button .arrow {\n  width: 20px;\n  margin-right: 38px;\n}\n\n@media only screen and (max-width: 768px) {\n  .categories-button {\n    width: 247px;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .categories-button {\n    margin-top: 20px;\n    margin-right: 20px;\n    margin-left: 0px;\n    width: auto;\n    height: 70px;\n  }\n\n  .categories-button .arrow {\n    margin-right: 32px;\n  }\n}\n\n/* pathBuilder */\n.path-builder {\n  display: flex;\n  margin-top: 40px;\n}\n\n.path-builder .breadcrumbs {\n  margin-left: 10px;\n  text-align: left;\n  line-break: anywhere;\n  padding-right: 45px;\n}\n\n\n.path-builder .path-part {\n  cursor: pointer;\n  text-align: left;\n}\n\n.path-builder .path-part .path:hover {\n  text-decoration: underline;\n}\n\n.path-builder .all-categories {\n  display: flex;\n  padding-top: 2px;\n  cursor: pointer;\n}\n\n.path-builder div {\n  font-size: 18px;\n  color: rgba(255, 255, 255, 0.6);\n  font-weight: 500;\n  line-height: 21.94px;\n}\n\n@media only screen and (max-width: 1200px) {\n  .path-builder .breadcrumbs {\n    padding-right: 0px;\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .path-builder {\n    padding: 0 20px 0 0;\n  }\n}\n\n@media only screen and (max-width: 320px) {\n  .path-builder {\n    margin-bottom: 20px;\n    justify-content: unset;\n  }\n\n  .path-builder .breadcrumbs {\n    display: flex;\n    flex-direction: column;\n    line-break: unset;\n  }\n\n  .path-builder div {\n    text-transform: uppercase;\n  }\n}\n\n/* sectionBuilder */\n.gear-icons {\n  display: flex;\n  flex-basis: 20%;\n  margin-right: 10px;\n  width: 30px;\n  height: 30px;\n  justify-content: center;\n  align-items: center;\n}\n\n.gear-icons .gear-section-small-gear {\n  position: absolute;\n  left: 38px;\n  top: 10px;\n}\n\n.content-wrapper {\n  display: inline-flex;\n}\n\n.content-wrapper .tooltip-text {\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n}\n\n.section-builder {\n  margin-top: 50px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.section-builder .section-title {\n  font-size: 70px;\n  color: rgba(255, 255, 255, 0.6);\n  line-height: 85px;\n  font-weight: bolder;\n  margin-bottom: 10px;\n}\n\n.section-builder .section-subtitle {\n  font-size: 26px;\n  color: #ffffff99;\n  font-weight: 500;\n  margin-top: 10px;\n  margin-bottom: 20px;\n}\n\n.section-builder .section-option-wrapper {\n  display: flex;\n  width: calc(75% + 30px);\n  /*margin-left: 15%;*/\n  /* flex-direction: column; */\n  flex-wrap: wrap;\n  margin-bottom: 30px;\n}\n\n.section-builder .section-option-wrapper .section-option {\n  /* display: flex; */\n  height: 50px;\n  border: 2px solid #FFFFFFB2;\n  /* justify-content: center; */\n  align-items: center;\n  border-radius: 40px;\n  text-transform: none !important;\n  background-color: transparent;\n  margin-right: 30px;\n  margin-top: 15px;\n  cursor: pointer;\n  /* backdrop-filter: blur(20px); */\n}\n\n.active {\n  color: #212121 !important;\n  background: rgba(255, 255, 255, 0.7) !important;\n}\n\n.section-builder .section-option-wrapp {\n  display: flex;\n  /* flex-direction: column; */\n  flex-wrap: wrap;\n  margin-bottom: 30px;\n}\n\n.section-builder .section-option-wrapp .section-option {\n  display: flex;\n  border-top: 1px solid rgba(185, 180, 180, 0.3);\n  justify-content: center;\n  align-items: center;\n  border-radius: 10px;\n  text-transform: uppercase;\n  background-color: rgba(255, 255, 255, 0.3);\n  margin-right: 30px;\n  margin-top: 15px;\n  cursor: pointer;\n  backdrop-filter: blur(20px);\n}\n\n.section-builder .section-option-wrapper .section-option.active {\n  background: rgba(255, 255, 255, 0.3);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\n}\n\n.section-builder .section-option-wrapper .section-option span {\n  padding: 20px 50px;\n  padding-top: 40px;\n  /* padding-left: 15%; */\n  font-weight: 700;\n  font-size: 14px;\n  text-transform: uppercase;\n  line-height: 17.07px;\n  color: rgba(255, 255, 255, 1);\n}\n\n.section-builder .section-option-wrapper .section-option.active span {\n  /*padding: 26px 15px 26px 50px;*/\n  color: #555555;\n}\n\n.section-builder .section-option-wrapper .section-option.active span svg {\n  margin-left: 17.4px;\n  fill: #555555;\n  width: 17.6px;\n}\n\n.section-builder .section-option-wrapper .section-option.active span svg path {\n  fill: #555555;\n}\n\n.section-builder .section-data-wrapper .section-data-item {\n  margin-bottom: 40px;\n}\n\n.section-builder .section-data-wrapper .section-data-item:last-child {\n  margin-bottom: 0;\n}\n\n.section-builder .section-data-wrapper .section-data-item .section-data-title {\n  height: 10%;\n  padding-top: 30px;\n  font-size: 35px;\n  font-weight: bolder;\n  color: rgba(255, 255, 255, 0.6);\n  margin-bottom: 10px;\n  text-align: left;\n  padding-left: 15%;\n}\n\n.section-builder\n.section-data-wrapper\n.section-data-item\n.section-data-description {\n  height: 55%;\n  width: 75%;\n  padding-left: 15%;\n  padding-top: 30px;\n  font-size: 16px;\n  color: #ffffff;\n  font-weight: 500;\n  line-height: 25px;\n  text-align: left;\n}\n\n@media only screen and (max-width: 1200px) {\n  .section-builder\n  .section-data-wrapper\n  .section-data-item\n  .section-data-title {\n    font-size: 24px;\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .section-builder .section-option-wrapper {\n    margin-bottom: 20px;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .section-builder {\n    display: flex;\n    text-align: center;\n    flex-direction: column;\n    justify-content: center;\n    margin-top: 20px;\n  }\n\n  .section-builder .section-title,\n  .section-builder .section-subtitle {\n    text-transform: uppercase;\n    font-weight: 800;\n    font-size: 18px;\n    line-height: 22px;\n    margin: 0;\n  }\n\n  .section-builder .section-option-wrapper .section-option {\n    width: 100%;\n    margin-right: 0;\n    text-align: center;\n  }\n\n  .section-builder .section-option-wrapper .section-option span {\n    padding: 0;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .section-builder .section-option-wrapper .section-option.active .check-icon {\n    margin-right: 20px;\n  }\n\n  .section-builder .section-option-wrapper .section-option .check-icon svg {\n    position: absolute;\n    right: 50px;\n  }\n\n  .section-builder .section-option-wrapper {\n    justify-content: center;\n    align-items: center;\n  }\n}\n\n@media only screen and (max-width: 320px) {\n  .section-builder\n  .section-data-wrapper\n  .section-data-item\n  .section-data-title {\n    word-break: break-all;\n  }\n}\n\n/* thank form */\n.thank-you-message-container {\n  display: flex;\n  flex-direction: column;\n  margin-top: 30px;\n}\n\n.thank-you-message-container .thank-you-message-title {\n  font-size: 36px;\n  line-height: 60px;\n  font-weight: bolder;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.thank-you-message-container > * {\n  margin-bottom: 10px;\n}\n\n.thank-you-message-container .thank-you-message-content {\n  font-size: 20px;\n  color: #ffffff;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.thank-you-message-container .thank-you-message-button {\n  margin-top: 10px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.thank-you-message-container .thank-you-message-button button {\n  font-family: \"Montserrat\";\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 21.94px;\n  width: 370px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n@media only screen and (max-width: 480px) {\n  .thank-you-message-container .thank-you-message-title {\n    font-size: 16px;\n  }\n\n  .thank-you-message-container .thank-you-message-button {\n    text-align: center;\n  }\n\n  .thank-you-message-container .thank-you-message-button button {\n    width: 220px;\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 14.63px;\n  }\n}\n.error-message {\n  font-family: \"Montserrat\";\n  width: 77%;\n  color: red;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 21.94px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
